import { useState } from 'react';
import { ContentHeader, Table } from '@app/shared';
import { ChargeOffReasonForm } from './ChargeOffReasonForm';
import { useChargeOffReasons } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';

export function ChargeOffReasons() {
  const [selectedReason, setSelectedReason] = useState(undefined as any);
  const { data: chargeOffReasons } = useChargeOffReasons();

  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'reason', headerName: 'Reason' },
  ];

  const master = (
    <>
      <ContentHeader>
        Charge Off Reasons
        <button className={'ui button'} onClick={() => setSelectedReason(undefined)} disabled>
          Add Charge Off Reason
        </button>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table items={chargeOffReasons} onSelectItem={setSelectedReason} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>{selectedReason ? 'Update Charge Off Reason' : 'Add Charge Off Reason'}</ContentHeader>
      <ChargeOffReasonForm key={JSON.stringify(selectedReason)} chargeOffReason={selectedReason} />
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
